import NotificationsCard from "./NotificationsCard";

export default NotificationsCard;